/* eslint-disable no-unused-vars */
import React,{useState} from "react";
import { downloadGradient, setGradient } from "../../actions/gradientAction";
import { useDispatch } from "react-redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Container,Box,GradientScreen,GradientInfo,GradientTags,GradientCopy,Tag,ColorCircle,Button,Popover,PopoverNone,CircleMain} from '../../styles/Gradient-Styles';

const Gradient = (props) => {

  const notify = (prop) => toast.info(prop, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    });;

  const dispatch = useDispatch();
  const [popover1, setPopover1] = useState(false);
  const [popover2, setPopover2] = useState(false);
  const [popover3, setPopover3] = useState(false);
  const { gradient } = props;
  const { name, colors } = gradient;
  return (
    <Container>
      <Box>
          <GradientScreen
          onClick={() => dispatch(setGradient(gradient))}
          style={{backgroundImage: `linear-gradient(${gradient.colors.direction}, ${gradient.colors.start}, ${gradient.colors.end})`}}
          >
          </GradientScreen>
          <GradientInfo>
          <GradientTags>
          <CopyToClipboard text={gradient.colors.start}>
          <CircleMain  onMouseEnter = {()=>setPopover1(true)} onMouseLeave={()=>setPopover1(false)} onClick={()=>notify("Copied Successfully")}>
          {popover1 ? <Popover popover1>{gradient.colors.start}</Popover> : <PopoverNone/>}
                  <Tag><ColorCircle style={{background:`${gradient.colors.start}`}}></ColorCircle></Tag>
          </CircleMain>
          </CopyToClipboard>
         
          <CopyToClipboard text={gradient.colors.end}>
          <CircleMain onMouseEnter = {()=>setPopover2(true)} onMouseOver = {()=>setPopover2(true)} onMouseLeave={()=>setPopover2(false)} onClick={()=>notify("Copied Sucessfully")}>
          {popover2 ? <Popover popover2>{gradient.colors.end}</Popover> : <PopoverNone/>}
                  <Tag>
                    <ColorCircle id="Popover1" style={{background:`${gradient.colors.end}`}}></ColorCircle>
                    </Tag>
          </CircleMain>
          </CopyToClipboard>
            </GradientTags>
            <GradientCopy>
            <CopyToClipboard
                  text={`background-image:linear-gradient(${colors.direction}, ${colors.start}, ${colors.end})`}
                >
            <Button onMouseEnter = {()=>setPopover3(true)} onMouseOver = {()=>setPopover3(true)} onMouseLeave={()=>setPopover3(false)} onClick={()=>notify("Css Copied")}>
            {popover3 ? <Popover popover3>Copy_CSS</Popover>:<PopoverNone/>}
                
                  <span className="material-icons">copy_all</span>
              </Button>
                </CopyToClipboard>
            </GradientCopy>
          </GradientInfo>  
          </Box>
      </Container>
  );
};

export default Gradient;